<template>
  <div class="detail-container disp-scroll">
    <!-- URLコピー用 -->
    <input type="hidden" style="opacity: 0 !important;" id="copy_code_detail" :value="singleURL"/>
    <!-- モーダル部 -->
    <DetailConvResult
      :isShowModal="isDetailConvResult"
      :chatbot="chatbot"
      @cancel="changeConvResult"/>
    <DetailChatBotSetting
      :isShowModal="isDetailChatBotSetting"
      :chatbot="JSON.parse(JSON.stringify(chatbot))"
      :users="users"
      :user="user"
      @cancel="changeChatBotSetting"
      @setIcon="setIcon"
      @updateChatBot="updateChatBot"
      :PCTRLLOG="CTRLLOG"/>
    <DetailMiniSetting
      :isShowModal="isDetailMiniSetting"
      :chatbot="chatbot"
      :mediaCooperationItemMasterNameList="mediaCooperationItemMasterNameList"
      :users="users"
      :user="user"
      :calendarSettings="calendarSettings"
      :usersStatusAPI="usersStatusAPI"
      @cancel="changeMiniSetting"
      @setIcon="setIconMini"
      @updateChatBot="updateChatBot"
      :PCTRLLOG="CTRLLOG"/>
    <DetailURLSetting
      :isShowModal="isDetailURLSetting"
      :chatbot="JSON.parse(JSON.stringify(chatbot))"
      @cancel="changeURLSetting"/>
    <DetailArchiveDelete
      :isShowModal="isDetailArchiveDelete"
      :chatbot="chatbot"
      @cancel="changeArchiveDelete"
      @archiveChatBot="archiveChatBot"
      :PCTRLLOG="CTRLLOG"/>
    <DetailScenarioEditStats
      :isShowModal="isDetailScenarioEditStats"
      :chatbot="chatbot"
      @cancel="changeScenarioEditStats"/>
    <DetailRoboConfirm
      :isShowModal="isDetailRoboConfirm"
      :chatbot="chatbot"
      :user="user"
      @cancel="changeRoboConfirm"
      @clickRoboLock="clickRoboLock"
      @changeByParts="changeByParts"
      @changeByStories="changeByStories"/>
    <DetailByParts
      :isShowModal="isDetailByParts"
      @cancel="changeByParts"
    />
    <DetailByStories
      :isShowModal="isDetailByStories"
      @cancel="changeByStories"
    />
    <!-- ヘッダー部分：名前、タグ -->
    <div class="header-container">
      <div class="favorite" v-bind:class="{'no_favorite':!isBookMarkBots(chatbot)}">
        <span class="mdi mdi-star" @click="changeBookMark(chatbot, uses)"></span>
      </div>
      <h2>{{chatbot.name}}</h2>
      <div class="archive-delete-box">
        <Tooltip message="エクスポート">
          <button class="button is-success is-small" style="margin-right: 8px;" @click="exportChatbot()" v-if="!chatbot.is_archive" :disabled="!isRoboEditPermission(chatbot, this.user)">
            <span class="mdi mdi-export"></span>
          </button>
        </Tooltip>
        <Tooltip message="アーカイブ">
          <button class="button is-danger is-small" @click="changeArchiveDelete(true)" v-if="!chatbot.is_archive" :disabled="!isRoboEditPermission(chatbot, this.user)">
            <span class="mdi mdi-archive"></span>
          </button>
        </Tooltip>
        <Tooltip message="アーカイブから戻す">
          <button class="button is-success is-small" style="margin-right: 8px;" @click="changeArchiveDelete(true)" v-if="chatbot.is_archive" :disabled="!isRoboEditPermission(chatbot, this.user)">
            <span class="mdi mdi-backup-restore"></span>
          </button>
        </Tooltip>
        <Tooltip message="削除">
          <button class="button is-danger is-small" @click="deleteChatBot(chatbot)" v-if="chatbot.is_archive" :disabled="!isRoboEditPermission(chatbot, this.user)">
            <span class="mdi mdi-delete"></span>
          </button>
        </Tooltip>
      </div>
    </div>
    <div class="tag-container">
      <ChatBotTags
        :chatbot="chatbot"
        :isEdit="true"
        :isNew="false"/>
    </div>
    <!-- アイコン、データ詳細 -->
    <div class="data-icon-container">
      <div class="icon-box">
        <img class="chatbot-icon" :src="getIconURL(chatbot)" @click="changeChatBotSetting(true)">
        <!--
        <button class="button is-small is-primary" @click="copySinglePageURL(chatbot)">
          <span class="mdi mdi-link-variant -right-8px"></span>
          ロボリンク取得
        </button>
        -->
        <button class="button" @click="changeURLSetting(true)"
          :class="[chatbot.is_confirm ? 'allowButton' : 'noAllowButton']" :disabled="!chatbot.is_confirm">
          勤務開始
        </button>
      </div>
      <div class="data-box">
        <ChatBotData
          :chatbot="chatbot"
          :userChatBotBookMark="userChatBotBookMark"
          :sitemapRootList="sitemapRootList"
          :sitemapEmploymentList="sitemapEmploymentList"
          @chatbotLoading="chatbotLoading"/>
      </div>
    </div>
    <!-- メニューボタン -->
    <div class="menu-container">
      <!--
      <button class="button" @click="changeBookMark(chatbot, uses)">{{!isBookMarkBots(chatbot) ? 'お気に入り' : 'お気に入りから外す'}}</button>
      <button class="button" @click="changeConvResult(true)">回答内容・送付履歴リスト</button>
      <button class="button" @click="openChatBotPreview(chatbot)">ロボ画面プレビュー</button>
      <button class="button" @click="movePartsEdit(chatbot)">ロボパーツ編集</button>
      <button class="button" @click="changeChatBotSetting(true)">表示・確認設定</button>
      <button class="button" @click="changeURLSetting(true)">ロボ勤務地設定</button>
      <button class="button" @click="changeArchiveDelete(true)">アーカイブ</button>
      <button class="button" @click="changeScenarioEditStats(true)" v-if="user.isAgent">シナリオ編集記録</button>
      <button class="button" @click="changeMiniSetting(true)" v-if="user.isAgent">ミニロボ別設定</button>
      -->
      <button
        class="button"
        @click="movePartsEdit(chatbot)"
        :disabled="!isRoboEditPermission(chatbot)">
        シナリオ編集
      </button>
      <button
        class="button"
        @click="changeScenarioEditStats(true)"
        v-if="user.isAgent">
        シナリオ編集記録
      </button>
      <button
        class="button"
        @click="changeRoboConfirm(true)"
        :disabled="isLoading || !isRoboEditPermission(chatbot)">
        プレビュー / 確定
      </button>
      <button
        class="button"
        @click="copySinglePageURL(chatbot)"
        :class="[chatbot.is_confirm ? '' : 'noAllowButton']"
        :disabled="!chatbot.is_confirm">
        ロボリンク取得
      </button>
      <button
        class="button"
        @click="changeMiniSetting(true)"
        v-if="user.isAgent"
        :class="[chatbot.is_confirm ? '' : 'noAllowButton']"
        :disabled="!chatbot.is_confirm">
        ミニロボ別設定
      </button>
      <button
        class="button"
        @click="changeConvResult(true)"
        :class="[chatbot.is_confirm ? '' : 'noAllowButton']"
        :disabled="!chatbot.is_confirm">
        データ
      </button>
      <p v-if="chatbot.is_archive">
        ※現在アーカイブされております。
      </p>
      <p v-if="isMiniBot(chatbot)">
        ※ミニロボが設定されております。
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DetailConvResult     from '@/components/ChatBot/organisms/DetailConvResult'
import DetailChatBotSetting from '@/components/ChatBot/organisms/DetailChatBotSetting'
import DetailURLSetting     from '@/components/ChatBot/organisms/DetailURLSetting'
import DetailArchiveDelete  from '@/components/ChatBot/organisms/DetailArchiveDelete'
import DetailMiniSetting    from '@/components/ChatBot/organisms/DetailMiniSetting'
import ChatBotTags          from '@/components2/Common/Screen/organisms/ChatBotTags'
import ChatBotData          from '@/components/ChatBot/organisms/ChatBotData'
import DetailScenarioEditStats    from '@/components/ChatBot/organisms/DetailScenarioEditStats'
import DetailRoboConfirm    from '@/components2/Robo/modal/organisms/DetailRoboConfirm'
import DetailByParts        from '@/components/ChatBot/organisms/DetailByParts'
import DetailByStories      from '@/components/ChatBot/organisms/DetailByStories'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import controlLogMixin from '@/mixins/controlLogMixin'
import {
  isRoboEditPermission,
} from '@/functions/checkPermission'

export default {
  components: {
    DetailConvResult,
    DetailChatBotSetting,
    DetailURLSetting,
    DetailArchiveDelete,
    DetailMiniSetting,
    ChatBotTags,
    ChatBotData,
    DetailScenarioEditStats,
    DetailRoboConfirm,
    DetailByParts,
    DetailByStories,
    Tooltip
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    chatbot: {
      type: Object,
      required: true
    },
    userChatBotBookMark: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    sitemapRootList: {
      type: Array,
      required: true
    },
    sitemapEmploymentList: {
      type: Array,
      required: true
    },
    isDetailChatBotSetting: {
      type: Boolean,
      required: true
    },
    changeChatBotSetting: {
      type: Function,
      required: true
    },
    uses: {
      type: String,
      required: false,
    },
    usersStatusAPI: {
      type: Array,
      required: true
    },
    /**
     * 媒体連携項目マスター一覧
     * @type {Array}
     */
    mediaCooperationItemMasterNameList: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      singleURL: null,
      isDetailConvResult: false,
      isDetailMiniSetting: false,
      isDetailURLSetting: false,
      isDetailArchiveDelete: false,
      isDetailScenarioEditStats: false,
      roboIconHover: false,
      isDetailRoboConfirm: false,
      isDetailByParts: false,
      isDetailByStories: false,
      isLoading: true,
    }
  },
  computed: {
    ...mapState('auth', ['calendarSettings']),
  },
  mounted () {
    this.$store.dispatch('auth/getUserCalendarSetting', null)
  },
  methods: {
    // ミニロボ有無チェック
    isMiniBot (chatbot) {
      let isMini = false
      if (chatbot.chatbot_mini) {
        if (chatbot.chatbot_mini.length > 0) {
          isMini = true
        }
      }
      return isMini
    },
    modalActiveSelectMedia () {
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    // icon 表示
    getIconURL (chatbot) {
      if (chatbot.icon_data) {
        return chatbot.icon_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    // ロボリンク取得
    copySinglePageURL (chatbot) {
      this.singleURL = process.env.OWN_ENDPOINT + '/single/' + chatbot.group + '/' + chatbot.bot_id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy_code_detail')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    // お気に入りかどうか
    isBookMarkBots (chatbot) {
      for (const cb of this.userChatBotBookMark) {
        if (cb.chatbot === chatbot.bot_id) {
          return true
        }
      }
      return false
    },
    changeBookMark (chatbot, uses) {
      this.$emit('changeBookMark', chatbot)
      if (uses === 'bookmark') {
        this.archiveModalClose()
      }
    },
    changeConvResult (flg) {
      this.isDetailConvResult = flg
    },
    openChatBotPreview (chatbot) {
      const url = process.env.OWN_ENDPOINT + '/single/demo/' + chatbot.group + '/' + chatbot.scenario_name
      const h = window.outerHeight
      const w = window.outerWidth / 2
      window.open(url, '_blank', 'width=' + w + 'px, height=' + h + 'px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')
    },
    setIcon (id) {
      // iconの更新
      this.$emit('setIcon', {
        chatbot: this.chatbot,
        id: id,
        miniIdx: -1
      })
    },
    setIconMini (data) {
      // iconの更新
      this.$emit('setIcon', data)
    },
    deleteIcon (chatbot) {
      this.$emit('setIcon', {
        chatbot: chatbot,
        id     : null,
        miniIdx: -1
      })
    },
    movePartsEdit (chatbot) {
      this.$emit('movePartsEdit', chatbot)
    },
    changeMiniSetting (flg) {
      this.isDetailMiniSetting = flg
    },
    updateChatBot (chatbot) {
      this.$emit('updateChatBot', chatbot)
    },
    changeURLSetting (flg) {
      this.isDetailURLSetting = flg
    },
    changeArchiveDelete (flg) {
      this.isDetailArchiveDelete = flg
    },
    changeScenarioEditStats (flg) {
      if (flg) {
        this.$store.dispatch('chatbot/getScenarioEditStats', {
          chatbot: this.chatbot.bot_id,
        })
      }
      this.isDetailScenarioEditStats = flg
    },
    deleteChatBot (chatbot) {
      this.$emit('deleteChatBot', chatbot)
    },
    createChatBotTags (e) {
      this.$emit('createChatBotTags', e)
    },
    deleteChatBotTags (e) {
      this.$emit('deleteChatBotTags', e)
    },
    archiveChatBot (chatbot) {
      this.updateChatBot(chatbot)
      this.archiveModalClose()
    },
    archiveModalClose () {
      this.$emit('cancel', false)
    },
    exportChatbot () {
      this.$store.dispatch('chatbot/exportBot', {company_id: this.chatbot.group, id: this.chatbot.bot_id})
    },
    changeRoboConfirm (flg) {
      this.isDetailRoboConfirm = flg
    },
    clickRoboLock (chatbot) {
      this.$emit('clickRoboLock', chatbot)
    },
    changeByParts (scenario) {
      this.$store.dispatch('chatbot/changeModalEditScenario')
      if (scenario) {
        this.$store.dispatch('chatbot/confirmByParts', scenario)
      }
    },
    changeByStories (scenario) {
      this.$store.dispatch('chatbot/getScenarioList', { companyid: this.chatbot.group, scenarioName: this.chatbot.scenario_name })
      .then((d) => {
        this.$store.dispatch('chatbot/changeModalEditScenario')
        if (scenario) {
          this.$store.dispatch('chatbot/confirmByStories', d.data)
        }
      })
    },
    chatbotLoading () {
      this.isLoading = false
    },
    isRoboEditPermission (robo) {
      return isRoboEditPermission(robo, this.user)
    }
  }
}
</script>

<style lang="scss" scoped>
.bulk-action-container {
  padding: 8px;
}
.header-container {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 28px 5px;
  h2 {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    color: #C82E42;
    width: calc(100% - 140px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .archive-delete-box{
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .favorite {
    margin: -8px 8px 0px 0px;
    font-size: 32px;
    color: #ffd700;
    cursor: pointer;
  }
  .no_favorite {
    color: #d3d3d3;
  }
  /deep/ .tag-c {
    flex-wrap: wrap !important;
    overflow: auto !important;
  }
}
.data-icon-container {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 0 16px;
  align-items: center;
  .icon-box {
    width: 40%;
    text-align: center;
    .delete-button {
      position: absolute;
      top:   -180px;
      right: -5px;
      height: 20px;
      width:  20px;
      border-radius: 50%;
      line-height: 0.95;
      border: solid thin #ccc;
      background: rgb(255, 255, 255);
      cursor: pointer;
    }
    .chatbot-icon {
      width: 180px;
      height: 180px;
      object-fit: cover;
      border-radius: 50%;
      border: solid thin #ccc;
      cursor: pointer;
    }
    button {
      margin-top: 8px;
    }
  }
  .data-box {
    width: 60%;
    padding-left: 16px;
    text-align: left;
    .record {
      display: flex;
      width: 100%;
      .left-col {
        width: 200px;
      }
      .right-col {
        width: calc(100% - 200px);
      }
    }
  }
}
.menu-container {
  width: 100%;
  padding: 16px 48px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  button {
    width: calc(50% - 8px);
    margin: 4px;
    background: #fffacd;
  }
  .noAllowButton{
    background: #c0c0c0;
  }
}
.allowButton {
  background: #fffacd;
}
.noAllowButton {
  background: #c0c0c0;
}
.tag-container {
  //height: 80px;
  padding-left: 50px;
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components2/Robo/modal/organisms/DetailMain.vue